import { render, staticRenderFns } from "./c_home_comb.vue?vue&type=template&id=b6d01582&scoped=true"
import script from "./c_home_comb.vue?vue&type=script&lang=js"
export * from "./c_home_comb.vue?vue&type=script&lang=js"
import style0 from "./c_home_comb.vue?vue&type=style&index=0&id=b6d01582&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d01582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d01582')) {
      api.createRecord('b6d01582', component.options)
    } else {
      api.reload('b6d01582', component.options)
    }
    module.hot.accept("./c_home_comb.vue?vue&type=template&id=b6d01582&scoped=true", function () {
      api.rerender('b6d01582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_comb.vue"
export default component.exports